"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Workflow", {
  enumerable: true,
  get: function get() {
    return _Workflow["default"];
  }
});
Object.defineProperty(exports, "WorkflowActionType", {
  enumerable: true,
  get: function get() {
    return _WorkflowActionType["default"];
  }
});
Object.defineProperty(exports, "WorkflowReactionType", {
  enumerable: true,
  get: function get() {
    return _WorkflowReactionType["default"];
  }
});
Object.defineProperty(exports, "Agent", {
  enumerable: true,
  get: function get() {
    return _Agent["default"];
  }
});
Object.defineProperty(exports, "Task", {
  enumerable: true,
  get: function get() {
    return _Task["default"];
  }
});
Object.defineProperty(exports, "ExecutedApproval", {
  enumerable: true,
  get: function get() {
    return _ExecutedApproval["default"];
  }
});
Object.defineProperty(exports, "ExecutedDocument", {
  enumerable: true,
  get: function get() {
    return _ExecutedDocument["default"];
  }
});
Object.defineProperty(exports, "ExecutedForm", {
  enumerable: true,
  get: function get() {
    return _ExecutedForm["default"];
  }
});
Object.defineProperty(exports, "ExecutionFlow", {
  enumerable: true,
  get: function get() {
    return _ExecutionFlow["default"];
  }
});
Object.defineProperty(exports, "CompanyArea", {
  enumerable: true,
  get: function get() {
    return _CompanyArea["default"];
  }
});
Object.defineProperty(exports, "Signing", {
  enumerable: true,
  get: function get() {
    return _Signing["default"];
  }
});
Object.defineProperty(exports, "Absense", {
  enumerable: true,
  get: function get() {
    return _Absense["default"];
  }
});
Object.defineProperty(exports, "Recurrence", {
  enumerable: true,
  get: function get() {
    return _Recurrence["default"];
  }
});
Object.defineProperty(exports, "ProcessDocument", {
  enumerable: true,
  get: function get() {
    return _ProcessDocument["default"];
  }
});
Object.defineProperty(exports, "WorkflowPhase", {
  enumerable: true,
  get: function get() {
    return _WorkflowPhase["default"];
  }
});
Object.defineProperty(exports, "WorkflowPhaseAction", {
  enumerable: true,
  get: function get() {
    return _WorkflowPhaseAction["default"];
  }
});
Object.defineProperty(exports, "WorkflowExpiration", {
  enumerable: true,
  get: function get() {
    return _WorkflowExpiration["default"];
  }
});
Object.defineProperty(exports, "WorkflowPhaseReaction", {
  enumerable: true,
  get: function get() {
    return _WorkflowPhaseReaction["default"];
  }
});

var _Workflow = _interopRequireDefault(require("./models/Workflow"));

var _WorkflowActionType = _interopRequireDefault(require("./shapes/WorkflowActionType"));

var _WorkflowReactionType = _interopRequireDefault(require("./shapes/WorkflowReactionType"));

var _Agent = _interopRequireDefault(require("./models/Agent"));

var _Task = _interopRequireDefault(require("./models/Task"));

var _ExecutedApproval = _interopRequireDefault(require("./models/ExecutedApproval"));

var _ExecutedDocument = _interopRequireDefault(require("./models/ExecutedDocument"));

var _ExecutedForm = _interopRequireDefault(require("./models/ExecutedForm"));

var _ExecutionFlow = _interopRequireDefault(require("./models/ExecutionFlow"));

var _CompanyArea = _interopRequireDefault(require("./models/CompanyArea"));

var _Signing = _interopRequireDefault(require("./models/Signing"));

var _Absense = _interopRequireDefault(require("./models/Absense"));

var _Recurrence = _interopRequireDefault(require("./models/Recurrence"));

var _ProcessDocument = _interopRequireDefault(require("./shapes/ProcessDocument"));

var _WorkflowPhase = _interopRequireDefault(require("./shapes/WorkflowPhase"));

var _WorkflowPhaseAction = _interopRequireDefault(require("./shapes/WorkflowPhaseAction"));

var _WorkflowExpiration = _interopRequireDefault(require("./shapes/WorkflowExpiration"));

var _WorkflowPhaseReaction = _interopRequireDefault(require("./shapes/WorkflowPhaseReaction"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }